module.exports = __webpack_public_path__ + "static/img/main-title.ba18ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main-title.jpg
// module id = TNb3
// module chunks = 1